import { IPaymentProcessingState } from '../initialStates/paymentProcessing';
import { RootState } from '../../../redux/store';

export const paymentProcessingSelector = (state: RootState): IPaymentProcessingState =>
  state.paymentProcessing.paymentProcessing;
